import SessionService from "../../services/SessionService";

/**
 * Terminate current session and redirect user to the home page.
 */
export default function logout() {
	SessionService.getInstance().terminate();
	window.location.href = "/";
}
